import { PageAccess } from "@login";
import { Shield, CheckCircle, XCircle } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "visuais";

interface PermissionsCardProps {
  pageAccess: PageAccess;
}

export function PermissionsCard({ pageAccess }: PermissionsCardProps) {
  const getPermissionStatus = (hasPermission: boolean) => ({
    icon: hasPermission ? <CheckCircle /> : <XCircle />,
    color: hasPermission ? "text-success-foreground" : "text-muted-foreground",
    background: hasPermission ? "bg-success" : "bg-muted/60",
    text: hasPermission ? "font-semibold" : "text-muted-foreground/80",
  });

  return (
    <Card className="w-full shadow-lg shadow-primary/15">
      <CardHeader className="pb-4">
        <CardTitle className="flex items-center gap-2 text-foreground">
          <Shield className="w-5 h-5" />
          Permissões de Acesso
        </CardTitle>
        <CardDescription className="text-muted-foreground">
          Módulos e funcionalidades disponíveis para este usuário
        </CardDescription>
      </CardHeader>

      {/* CardContent com padding ajustado */}
      <CardContent className="pt-0">
        {/* Grid responsivo com gap adequado para o conteúdo */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
          {/* Item de Permissão: Administrador */}
          <div
            className={`flex flex-col items-center justify-center p-3 rounded-lg transition-colors min-h-[80px]
              ${getPermissionStatus(pageAccess.isAdmin).background}
              ${getPermissionStatus(pageAccess.isAdmin).color}
            `}
          >
            <div className="flex flex-col items-center gap-1">
              <div className="w-5 h-5">
                {getPermissionStatus(pageAccess.isAdmin).icon}
              </div>
              <span
                className={`text-xs text-center leading-tight ${
                  getPermissionStatus(pageAccess.isAdmin).text
                }`}
              >
                Administrador
              </span>
            </div>
          </div>

          {/* Item de Permissão: Contabilidade */}
          <div
            className={`flex flex-col items-center justify-center p-3 rounded-lg transition-colors min-h-[80px]
              ${getPermissionStatus(pageAccess.isContab).background}
              ${getPermissionStatus(pageAccess.isContab).color}
            `}
          >
            <div className="flex flex-col items-center gap-1">
              <div className="w-5 h-5">
                {getPermissionStatus(pageAccess.isContab).icon}
              </div>
              <span
                className={`text-xs text-center leading-tight ${
                  getPermissionStatus(pageAccess.isContab).text
                }`}
              >
                Contabilidade
              </span>
            </div>
          </div>

          {/* Item de Permissão: Compras */}
          <div
            className={`flex flex-col items-center justify-center p-3 rounded-lg transition-colors min-h-[80px]
              ${getPermissionStatus(pageAccess.isCompras).background}
              ${getPermissionStatus(pageAccess.isCompras).color}
            `}
          >
            <div className="flex flex-col items-center gap-1">
              <div className="w-5 h-5">
                {getPermissionStatus(pageAccess.isCompras).icon}
              </div>
              <span
                className={`text-xs text-center leading-tight ${
                  getPermissionStatus(pageAccess.isCompras).text
                }`}
              >
                Compras
              </span>
            </div>
          </div>

          {/* Item de Permissão: Borracharia */}
          <div
            className={`flex flex-col items-center justify-center p-3 rounded-lg transition-colors min-h-[80px]
              ${getPermissionStatus(pageAccess.isBorracharia).background}
              ${getPermissionStatus(pageAccess.isBorracharia).color}
            `}
          >
            <div className="flex flex-col items-center gap-1">
              <div className="w-5 h-5">
                {getPermissionStatus(pageAccess.isBorracharia).icon}
              </div>
              <span
                className={`text-xs text-center leading-tight ${
                  getPermissionStatus(pageAccess.isBorracharia).text
                }`}
              >
                Borracharia
              </span>
            </div>
          </div>

          {/* Item de Permissão: Portaria */}
          <div
            className={`flex flex-col items-center justify-center p-3 rounded-lg transition-colors min-h-[80px]
              ${getPermissionStatus(pageAccess.isPortaria).background}
              ${getPermissionStatus(pageAccess.isPortaria).color}
            `}
          >
            <div className="flex flex-col items-center gap-1">
              <div className="w-5 h-5">
                {getPermissionStatus(pageAccess.isPortaria).icon}
              </div>
              <span
                className={`text-xs text-center leading-tight ${
                  getPermissionStatus(pageAccess.isPortaria).text
                }`}
              >
                Portaria
              </span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
